"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
/** @jsx jsx */
var core_1 = require("@theme-ui/core");
var react_1 = require("react");
var NarrowContainer = function (_a) {
    var children = _a.children;
    return (0, core_1.jsx)("div", { sx: { variant: "boxes.narrowContainer" } }, children);
};
exports.default = (0, react_1.memo)(NarrowContainer);
